import React from 'react';
import { RequestData } from '@hooks/usePredict';
import { PredictionResponse } from '@models/prediction';
import Config from '@utils/config';
import { HeaderTab } from '@components/commons';
import TimeoutCircularLoading, {
    DEFAULT_LOADING_MESSAGE,
    TIMEOUT_MESSAGE,
} from '@components/timeout-loading';
import AgeAntispoofingResponse from './AgeAntispoofingResponse';
import styles from './resultAgeAntispoofing.module.scss';
import { Button } from '@yoti/ui-kit-components-react/button';

interface Props {
    image: string;
    result?: PredictionResponse;
    onBackButtonClick: () => void;
    request?: RequestData;
}

const ResultAgeAntispoofing: React.FC<Props> = (props) => {
    const { image, result, onBackButtonClick, request } = props;

    return (
        <div className={styles['result']} data-qa="age-antispoofing-result">
            <HeaderTab className={styles['result__header']} tabs={['Result']} />
            <div className={styles['result__panel']}>
                <img
                    className={styles['result__panel__image']}
                    src={image}
                    alt="face"
                    data-qa="image-captured"
                />
                <div className={styles['result__panel__response']}>
                    {result ? (
                        <AgeAntispoofingResponse responseData={result} request={request} />
                    ) : (
                        <TimeoutCircularLoading
                            className={styles['result__panel__response__loading']}
                            message={DEFAULT_LOADING_MESSAGE}
                            timeoutMessage={TIMEOUT_MESSAGE}
                            timeout={Config.slowRequestNotificationTime}
                        />
                    )}
                </div>
            </div>
            <div className={styles['result__back-button']}>
                <Button onClick={onBackButtonClick}>Try again</Button>
            </div>
        </div>
    );
};

export default ResultAgeAntispoofing;
